import { type Board, blockedAt, occupancy, ray } from "./board";

/**
 * مرحله‌ی آفلاین: پازلِ تک‌نفره روی یک نقشِ تک‌رنگ (stages.ts). فلشِ آزاد بیرون می‌رود؛ فلشِ بسته به مانع می‌خورد و
 * یک قلب می‌برد — مثلِ نسخه‌های تک‌نفره‌ی این پازل، چون این‌جا حریفی نیست که یخ‌زدن برایش معنا داشته باشد. با
 * تمام‌شدنِ فلش‌ها مرحله تمام است و ستاره از قلب‌های مانده؛ با تمام‌شدنِ قلب‌ها مرحله از نو.
 * زمان‌ها میلی‌ثانیه‌اند و از بیرون داده می‌شوند، تا آزمون بی ساعتِ واقعی بدَوانَد.
 */
export const HEARTS = 3;

export interface Solo {
  board: Board;
  alive: boolean[];
  left: number;
  hearts: number;
  /** قلب‌های آغاز: مرحله‌ها سه، نقشه‌ی بزرگ پنج. */
  maxHearts: number;
  mistakes: number;
  start: number;
  /** میلی‌ثانیه از آغاز تا تمام‌کردن؛ null = هنوز. */
  finishedAt: number | null;
  /** قلب‌ها تمام شد. */
  lost: boolean;
}

export function newSolo(board: Board, start: number, hearts = HEARTS): Solo {
  return { board, alive: board.arrows.map(() => true), left: board.arrows.length, hearts, maxHearts: hearts, mistakes: 0, start, finishedAt: null, lost: false };
}

export type SoloTap =
  | { kind: "out"; dist: number; won: boolean }
  | { kind: "blocked"; dist: number; lost: boolean }
  | { kind: "none" };

export function soloTap(s: Solo, id: number, now: number): SoloTap {
  const a = s.board.arrows[id];
  if (!a || !s.alive[id] || s.finishedAt !== null || s.lost) return { kind: "none" };
  const block = blockedAt(s.board, occupancy(s.board, s.alive), a);
  if (block > 0) {
    s.mistakes++;
    s.hearts--;
    if (s.hearts <= 0) s.lost = true;
    return { kind: "blocked", dist: block, lost: s.lost };
  }
  const dist = ray(s.board, a).length;
  s.alive[id] = false;
  s.left--;
  if (s.left === 0) s.finishedAt = now - s.start;
  return { kind: "out", dist, won: s.left === 0 };
}

/**
 * ستاره‌ی مرحله‌ی تمام‌شده از قلب‌های مانده: همه سه، دست‌کم نیمی دو، کمتر یک — با سه قلب همان «هر قلب یک ستاره».
 */
export const starsOf = (s: Solo): number =>
  s.finishedAt === null ? 0 : s.hearts >= s.maxHearts ? 3 : 2 * s.hearts >= s.maxHearts ? 2 : 1;
